const initialState = {
  selectedValue: '',
  searchString: '',
};

export default initialState;